<app-modal>
  <div class="modal-header py-sm-4" header>
    <div class="container d-flex justify-content-between align-items-center">
      <div class="modal-title">
        <h1 class="m-0">EuroGeographics Open Data Licence</h1>
      </div>
      <button class="btn btn-secondary" type="button" aria-label="Close" (click)="close()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>
  <div class="modal-body pt-3 pt-lg-5" body>
    <div class="container" id="licenceModalTop">
      <app-licence-content></app-licence-content>
    </div>
  </div>
  <div class="py-3 modal-footer" footer>
    <div class="container d-flex justify-content-between align-items-center">
      <app-back-to-top target="licenceModalTop"></app-back-to-top>
      <button type="button" class="btn btn-secondary" (click)="close()">
        Close <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>
</app-modal>
